import { AdminCroissance } from "../../admin/adminCroissance/adminCroissance";

export const Croissance = () => {
  return <AdminCroissance />;
};